import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Pending } from 'components/Profile/Pending';
import { schedulesShape } from 'redux/saga/entities/schedules.shape';
import { deepExtract } from 'helpers/deep';
import { Confirmation } from '../ModalStates/Confirmation';
import { Failure } from '../ModalStates/Failure';
import { Inquiry } from '../ModalStates/Inquiry';
import { TopUp } from '../ModalStates/TopUp';
import { InviteAFriend } from '../ModalStates/InviteAFriend';
import { mapScheduleProperties } from '../Reservation.helpers';
export var ReservationModalFlow =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ReservationModalFlow, _PureComponent);

  function ReservationModalFlow() {
    _classCallCheck(this, ReservationModalFlow);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReservationModalFlow).apply(this, arguments));
  }

  _createClass(ReservationModalFlow, [{
    key: "renderConfirmation",
    value: function renderConfirmation() {
      var _this$props = this.props,
          onModalClose = _this$props.onModalClose,
          schedule = _this$props.schedule,
          referral = _this$props.referral,
          isReferralError = _this$props.isReferralError; // If the response from the campaign api contains
      // data, there's an active referral promotion for this reservation

      var hasInviteAFriend = deepExtract('campaign', referral);

      if (hasInviteAFriend && !isReferralError) {
        return React.createElement(InviteAFriend, {
          eventSource: "Post-Booking",
          onModalClose: onModalClose,
          referral: referral,
          schedule: schedule
        });
      }

      return React.createElement(Confirmation, {
        schedule: schedule,
        onModalClose: onModalClose
      });
    }
  }, {
    key: "renderFailure",
    value: function renderFailure() {
      var _this$props2 = this.props,
          isReservationError = _this$props2.isReservationError,
          onModalClose = _this$props2.onModalClose,
          schedule = _this$props2.schedule;

      var _mapSchedulePropertie = mapScheduleProperties(schedule),
          imageUrl = _mapSchedulePropertie.imageUrl,
          venueName = _mapSchedulePropertie.venueName;

      return React.createElement(Failure, {
        errorMessage: isReservationError.message,
        onModalClose: onModalClose,
        imageUrl: imageUrl,
        venueName: venueName
      });
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return React.createElement(Pending, null, React.createElement(Pending.CheckingAvailability, null));
    }
  }, {
    key: "renderConfirmTopUpReservation",
    value: function renderConfirmTopUpReservation() {
      var _this$props3 = this.props,
          creditsBalance = _this$props3.creditsBalance,
          endOfCycleDate = _this$props3.endOfCycleDate,
          msaTimeZone = _this$props3.msaTimeZone,
          onReservationRequest = _this$props3.onReservationRequest,
          schedule = _this$props3.schedule;
      return React.createElement(TopUp, {
        creditsBalance: creditsBalance,
        endOfCycleDate: endOfCycleDate,
        msaTimeZone: msaTimeZone,
        onReservationRequest: onReservationRequest,
        schedule: schedule
      });
    }
  }, {
    key: "renderConfirmReservation",
    value: function renderConfirmReservation() {
      var _this$props4 = this.props,
          endOfCycleDate = _this$props4.endOfCycleDate,
          msaTimeZone = _this$props4.msaTimeZone,
          onReservationRequest = _this$props4.onReservationRequest,
          schedule = _this$props4.schedule;
      return React.createElement(Inquiry, {
        endOfCycleDate: endOfCycleDate,
        msaTimeZone: msaTimeZone,
        onReservationRequest: onReservationRequest,
        schedule: schedule
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          isTopUp = _this$props5.isTopUp,
          isReservationLoading = _this$props5.isReservationLoading,
          isReferralLoading = _this$props5.isReferralLoading,
          isReservationLoaded = _this$props5.isReservationLoaded,
          isReservationError = _this$props5.isReservationError;

      if (isReservationLoading || isReferralLoading) {
        return this.renderLoading();
      }

      if (isReservationLoaded) {
        return this.renderConfirmation();
      }

      if (isReservationError) {
        return this.renderFailure();
      }

      return isTopUp ? this.renderConfirmTopUpReservation() : this.renderConfirmReservation();
    }
  }]);

  return ReservationModalFlow;
}(PureComponent);
ReservationModalFlow.propTypes = {
  isTopUp: PropTypes.bool.isRequired,
  // state props
  isReservationLoading: PropTypes.bool.isRequired,
  isReservationLoaded: PropTypes.bool.isRequired,
  isReservationError: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
  endOfCycleDate: PropTypes.number.isRequired,
  msaTimeZone: PropTypes.string.isRequired,
  creditsBalance: PropTypes.number.isRequired,
  referral: PropTypes.object,
  isReferralLoading: PropTypes.bool,
  isReferralError: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
  // dispatch props
  onModalClose: PropTypes.func.isRequired,
  onReservationRequest: PropTypes.func.isRequired,
  schedule: schedulesShape
};